import { Card, CardHeader, StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { BpM } from '../../../shared/brakepoints';
import { DisclosureInitialData, PrivatePersonDisclosureData } from '../../../model/disclosureData';
import DisclosureForm from '../container/DisclosureForm';
import Translator from '../../../components/Translator';
import { FormErrors } from 'redux-form';

type CssClasses = 'cardContent' | 'container';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  container: {
    width: '100%',
    [BpM()]: {
      width: '800px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardContent: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    fontSize: '17px',
  },
});

interface Props {
  disclosureId: string;
  disclosureData: DisclosureInitialData;
  onSubmit: (values: PrivatePersonDisclosureData) => Promise<any>;
}

const DisclosureLayout = ({ classes, disclosureId, disclosureData, onSubmit }: Props & WithStyles<CssClasses>) => (
  <Translator>
    {translate => {
      return (
        <Card className={classes.container}>
          <CardHeader title={translate('disclosureTitle')} />
          <div className={classes.cardContent}>
            <div dangerouslySetInnerHTML={{__html: translate('disclosureWelcomeText') }} />
            <DisclosureForm initalData={disclosureData} disclosureId={disclosureId} onSubmitHandler={onSubmit} />
          </div>
        </Card>
      );
    }}
  </Translator>
);

export default pure(withStyles(styles)(DisclosureLayout));



// WEBPACK FOOTER //
// ./src/routes/disclosure/components/DisclosureLayout.tsx